import {Component, Input, OnInit, SimpleChanges, ViewChild,} from '@angular/core';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import {MatDialog} from '@angular/material/dialog';
import {FormBuilder} from '@angular/forms';
import {AppTranslateService} from '../../../../../../../modules/services/translate/app-translate.service';
import {icons} from 'src/app/ui/icons';
import {DialogLotProduitComponent} from '../../../AvisAO/dialog-lot-produit/dialog-lot-produit.component';
import {Router} from '@angular/router';
import {TransferlistcheckedService} from '../../../AvisAO/dialog-lot-produit/transferlistchecked.service';
import {LotParentArt} from '../../../../acheteur/appel-offre/add-appel-offer/add-info-lot-offer/lot-offer-table/lot-offer-table.component';
import {AvisAOService, userInfot} from '../../../../../../../modules/services/actors/Fournisseur/appeloffreFournisseur/avis-ao.service';
import {isEmpty} from '../../../../../../../utils/is-empty';
import {DialogActeGroupementComponent} from '../../../actedegroupement/dialog-acte-groupement/dialog-acte-groupement.component';
import {TranferlistgroupementService} from '../../../actedegroupement/tranferlistgroupement.service';
import {GroupementService} from '../../../../../../../modules/services/fournisseur/actedegroupement/groupement.service';
import {EPConsor} from '../../../../../../../domain/groupement/BidClsConsor';
import {ToastService} from '../../../../../../../modules/toast/toast.service';
import {ConfirmDialogService} from '../../../../../../../modules/services/ui/confirm-dialog.service';
import {DatenowService} from '../../../../../../../modules/services/datenow.service';
import {CryptageFoService} from '../../../../../../../modules/services/actors/Fournisseur/cryptage-fo.service';
import {DialogCheckDateComponent} from '../../../consultation/list-consultation/dialog-check-date/dialog-check-date.component';
import {AppeloffreService} from '../../../../../../../modules/services/appel-offre/appeloffre.service';
import {DialogDateGroupementComponent} from '../dialog-date-groupement/dialog-date-groupement.component';
import {TranslateService} from '@ngx-translate/core';
import {LoginService} from '../../../../../../../modules/services/user/login/login.service';
import { ConsultationFoService } from 'src/app/modules/services/actors/Fournisseur/consultation/consultation-fo.service';

type Column = keyof any;

@Component({
    selector: 'app-table-participation-fournisseur',
    templateUrl: './table-participation-fournisseur.component.html',
    styleUrls: ['./table-participation-fournisseur.component.css'],
})
export class TableParticipationFournisseurComponent implements OnInit {
    @ViewChild(MatTable, {static: true}) table: MatTable<any>;
    @Input() data = [];
    @Input() detailsoffre: any;

    @Input() id;
    @Input() listchecked = [];
    @Input() epBidMasterId: any;
    @Input() list;
    displayedColumns: Column[] = ['bidCls'];
    displayedColumnss: (Column | 'action' | 'groupement')[] = [
        'bidCls',
        'licenseCd',
        'groupement',
        'action',
    ];
    dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
    labels: Partial<Record<Column, string>> = {
        licenseCd: 'Dossiers de candidature Participation et Résultats',
        bidCls: 'Evaluation des propositions techniques',
        Acte: 'Acte de groupement',
        Participation: 'Participation à l\'appel d\'offres',
    };

    icons = icons;
    @Input() bidNo: any;
    @Input() userinfo: userInfot;
    listbidcls = [];
    isnotsaved: any;
    curentdate: any;
    checkFlags: any = {};

    constructor(private consultationFoService: ConsultationFoService,
        private dialog: MatDialog,
        private formBuilder: FormBuilder,
        private appTranslateService: AppTranslateService,
        private router: Router,
        private trransfer: TransferlistcheckedService,
        private tranferlistgroupementService: TranferlistgroupementService,
        private groupementservice: GroupementService,
        private toast: ToastService,
        private confirmDialogService: ConfirmDialogService,
        private datenow: DatenowService,
        private cryptoservice: CryptageFoService,
        private appeloffreService: AppeloffreService,
        private ngxTranslateService: TranslateService,
        private aoservice: AvisAOService,
        private authService: LoginService,
    ) {
    }

    ngOnInit(): void {
        this.loadDataSource(this.data);
        this.getcolum();
        this.getdatenow();
        this.checkissavedoffre();
    }

    ngOnChanges(changes: SimpleChanges): void {
        const {data, detailsoffre} = changes;
        if (data.currentValue !== data.previousValue) {
            this.loadDataSource(data.currentValue);
        }
        if (detailsoffre.currentValue !== detailsoffre.previousValue) {
            // this.checkIfDossierCandidatuteBtnShown('IsAoPréselection');
            // this.checkIfDossierCandidatuteBtnShown('IsAo2Etapes');
        }
    }

    loadDataSource(data) {
        this.dataSource.data = data;
    }

    getcolum() {
        if (this.detailsoffre.consorYn == 'N') {
            return this.displayedColumnss.filter((column) => column !== 'groupement');
        } else {
            return this.displayedColumnss;
        }
    }

    isonlywithdinard() {
        return (
            this.detailsoffre.internationalBidYn === 'N' &&
            this.detailsoffre.financingYn === 'N' &&
            this.detailsoffre.frameworkYn === 'N' &&
            this.detailsoffre['procedureType'] !== '3' &&
            this.detailsoffre['procedureType'] !== '4' &&
            this.detailsoffre.onOffType != '3'
        );
    }

    particpate(element: any, i: any) {
        /*   const dialogRef = this.dialog.open(DialogLotProduitComponent, {
          disableClose: true,
          direction: this.appTranslateService.getDir(),

          data: {
            id: this.id,
            epbimaster: this.epBidMasterId,
            bidNo: this.bidNo,
            isgroupement: this.detailsoffre.consorYn == "Y",
          },
          width: "50vw",
        });*/
        const body = new EPConsor();
        body.bidNo = this.bidNo;
        body.bidModSeq = this.detailsoffre.bidModSeq;


        // this.groupementservice.checkGerant(body.bidNo, body.bidModSeq).subscribe({
        //     next: (response) => {
        //         if (response['code'] == '200') {
        //             if (!isEmpty(response['payload'])) {
        //                 this.confirmDialogService.error(this.ngxTranslateService.instant('gerant_already_participated') + response['payload']);
        //             } else {
        this.aoservice.checkSubmissionInProgress({
            bidNo: this.bidNo,
            bidModSeq: this.detailsoffre.bidModSeq,
            bizRegNo: this.authService.getAuthenticated().masterCd
        }).subscribe({
            next: (res1) => {
                if (res1['code'] == '200') {
                    if (res1['payload'] == 'Y') {
                        const dialogRef =  this.dialog.open(DialogCheckDateComponent, {
                            direction: this.appTranslateService.getDir(),
                            width: '30vw',
                            panelClass: 'custom-dialog-container',
                            data: {
                 
                                soum_cours:true
                            },
                        });
                        dialogRef.afterClosed().subscribe((result) => {
                            console.log('result ',result)
                            if(result==true)
                         {
                            this.consultationFoService.deleteAoProgress(this.bidNo, '00').subscribe(t => {
                                this.consultationFoService.deleteAoAttach(this.bidNo, '00').subscribe(t => {
                    
                                });
                            });
                         }
        
                        });
                    } else {
                        this.groupementservice.checkgrouupementisend(body).subscribe((res) => {

                            if (res == 'fail_consor') {
                                this.confirmDialogService.error('fail_consor').subscribe();
                            } else if (res) {

                                this.cryptoservice
                                    .checkdateoffre(this.id, this.detailsoffre.bidModSeq)
                                    .subscribe((x) => {
                                        this.getdatenow();
                                        this.checkissavedoffre();

                                        if (
                                            x['payload'].result == 'invalidDt' &&
                                            this.isnotsaved
                                        ) {

                                            this.dialog.open(DialogCheckDateComponent, {
                                                direction: this.appTranslateService.getDir(),
                                                width: '30vw',
                                                panelClass: 'custom-dialog-container',

                                                data: {
                                                    data: [this.detailsoffre],
                                                    start: x['payload'].dtStart,
                                                    end: x['payload'].dtEnd,
                                                    timeaff: true,
                                                    datatime: this.curentdate,
                                                    timedelai: false,
                                                    isnotsaved: this.isnotsaved,
                                                    offretime: true,
                                                },
                                            });
                                        } else if (!this.isnotsaved) {

                                            this.dialog.open(DialogCheckDateComponent, {
                                                direction: this.appTranslateService.getDir(),
                                                width: '25vw',
                                                panelClass: 'custom-dialog-container',
                                                data: {
                                                    data: [this.detailsoffre],
                                                    datatime: this.curentdate,
                                                    isnotsaved: this.isnotsaved,
                                                    timedelai: false,

                                                    offretime: false,
                                                },
                                            });
                                        } else {
                                            const canupload =
                                                this.detailsoffre.internationalBidYn == 'N' &&
                                                (this.detailsoffre.financingYn == 'N' ||
                                                    this.detailsoffre.financingYn == 'Sans') &&
                                                (this.detailsoffre.frameworkYn == 'N' ||
                                                    this.detailsoffre.frameworkYn == 'Non') &&
                                                this.detailsoffre.procedureType !== '3' &&
                                                this.detailsoffre.procedureType !== '4' &&
                                                this.detailsoffre.onOffType != '3';
                                            const dialogRef = this.dialog.open(DialogLotProduitComponent, {
                                                disableClose: true,
                                                direction: this.appTranslateService.getDir(),

                                                data: {
                                                    id: this.id,
                                                    epbimaster: this.epBidMasterId,
                                                    caupload: true,
                                                    bidNo: this.bidNo,
                                                    isgroupement: this.detailsoffre.consorYn == 'Y',
                                                    canupload: canupload,
                                                },
                                                width: '50vw',
                                            });
                                            dialogRef.afterClosed().subscribe((result1) => {
                                                if (!isEmpty(result1.data) && isEmpty(result1.submit)) {
                                                    this.router.navigate([
                                                        '/fournisseur/offres/' +
                                                        'particpationoffre' +
                                                        '/' +
                                                        this.epBidMasterId +
                                                        '/' +
                                                        this.bidNo,
                                                    ]);
                                                }

                                                if (!isEmpty(result1.data)) {
                                                    this.userinfo = result1.datauser;
                                                }

                                                let obj: LotParentArt = new LotParentArt();
                                                console.log('result1.data : ', result1.data);
                                                result1.data?.forEach((result) => {
                                                    obj.bidCls = result.bidCls;
                                                    obj.affectationcheck = result.affectationcheck;
                                                    obj.clsParentId = result.clsParentId;
                                                    obj.epBidTypCau = result.epBidTypCau;
                                                    obj.bidClsDtlDesc = result.bidClsDtlDesc;
                                                    obj.guaranteeAmountCurrF = result.guaranteeAmountCurrF;
                                                    obj.budgetAmtCurrF = result.budgetAmtCurrF;
                                                    obj.epBidMulCls = result.epBidMulCls;
                                                    obj.budgetAmt = result.budgetAmt;
                                                    obj.bidClsParent = result.bidClsParent;
                                                    obj.listLocalArticle = [];
                                                    this.listchecked.push(obj);
                                                    /*     /!*   this.listchecked.filter((a) => {
                                                      a.listLocalArticle.filter((b) => {});
                                                    });*/

                                                });
                                            });
                                        }
                                    });
                            } else {
                                this.toast.error();
                            }
                        });

                    }
                }
            },
            error: (e) => {
                console.error('Error in TableParticipationFournisseurComponent/checkSubmissionInProgress, erreur', e);
                this.toast.error();
            }
        });
        // }
        //         } else {
        //             this.toast.error();
        //             console.error('Error in TableParticipationFournisseurComponent/particpate, error code:: ', response['code'])
        //         }
        //     },
        //     error: (err)=>{
        //         this.toast.error();
        //         console.error('Error in TableParticipationFournisseurComponent/particpate, error:: ', err)
        //     }
        // });

    }

    particpatepreselection(element: any, i: any, ourCase) {


        const reqParams = {
            bidNo: this.detailsoffre['bidNo'],
            bidModSeq: this.detailsoffre['bidModSeq'],
        };
        this.appeloffreService
            .getResultData(
                'checkDateSoumission' + ourCase,
                null,
                reqParams,
                'fournisseur',
                'GET'
            )
            .subscribe({
                next: (response) => {

                    if (response['code'] == '200') {
                        if (response['payload'] == 'N') {
                            const dialogRef = this.dialog.open(DialogLotProduitComponent, {
                                disableClose: true,
                                direction: this.appTranslateService.getDir(),

                                data: {
                                    id: this.id,
                                    epbimaster: this.epBidMasterId,
                                    bidNo: this.bidNo,
                                    isgroupement: this.detailsoffre.consorYn == 'Y',
                                },
                                width: '50vw',
                            });
                            dialogRef.afterClosed().subscribe((result1) => {
                                if (!isEmpty(result1.data)) {


                                    this.router.navigate([
                                        '/fournisseur/offres/' +
                                        (this.detailsoffre['procedureType'] === '3' ||
                                        this.detailsoffre['procedureType'] === '4'
                                            ? 'dossiercandidature'
                                            : 'particpationoffre') +
                                        '/' +
                                        this.epBidMasterId +
                                        '/' +
                                        this.bidNo,
                                    ]);

                                    this.userinfo = result1.datauser;

                                    let obj: LotParentArt = new LotParentArt();

                                    result1.data.forEach((result) => {
                                        obj.bidCls = result.bidCls;
                                        obj.affectationcheck = result.affectationcheck;
                                        obj.clsParentId = result.clsParentId;
                                        obj.epBidTypCau = result.epBidTypCau;
                                        obj.bidClsDtlDesc = result.bidClsDtlDesc;
                                        obj.guaranteeAmountCurrF = result.guaranteeAmountCurrF;
                                        obj.budgetAmtCurrF = result.budgetAmtCurrF;
                                        obj.epBidMulCls = result.epBidMulCls;
                                        obj.budgetAmt = result.budgetAmt;
                                        obj.bidClsParent = result.bidClsParent;
                                        obj.listLocalArticle = [];
                                        this.listchecked.push(obj);
                                        /*   this.listchecked.filter((a) => {
                                                          a.listLocalArticle.filter((b) => {});
                                                        });*/

                                    });
                                }
                            });
                        } else if (response['payload'] == 'Y') {
                            this.datenow.getdatenow().subscribe((res) => {
                                this.dialog.open(DialogCheckDateComponent, {
                                    direction: this.appTranslateService.getDir(),
                                    width: '30vw',
                                    panelClass: 'custom-dialog-container',
                                    data: {
                                        data: [this.detailsoffre],
                                        start: this.detailsoffre['publicDtTimestamp'],
                                        end: this.detailsoffre[
                                            ourCase === 'DossierCandidature'
                                                ? 'pqRecvEndDt'
                                                : 'tpRecvEndDt'
                                            ],
                                        timeaff: true,
                                        datatime: res,
                                        timedelai: false,
                                        isnotsaved: this.isnotsaved,
                                        offretime: true,
                                        isPreselection: true,
                                    },
                                });
                            });
                        }
                    } else {
                        this.toast.error('server_error');
                    }
                },
                error: (e) => {
                    console.error(e);
                    this.toast.error('server_error');
                },
                complete: () => {
                },
            });
        // }
    }

    particpategroupement(element: any, i: any) {
        const body = new EPConsor();
        body.bidNo = this.bidNo;
        body.bidModSeq = this.detailsoffre.bidModSeq;
        this.groupementservice.checkoffreisend(body).subscribe((res) => {
            if (res == 'failedByExistBid') {
                this.confirmDialogService.error('offre_deja_soumis').subscribe();
            } else if (res) {
                this.cryptoservice
                    .checkdateoffreGroup(this.id, this.detailsoffre.bidModSeq)
                    .subscribe((x) => {
                        this.getdatenow();
                        this.checkissavedoffre();
                        if (x['payload'].result == 'invalidDt') {

                            this.dialog.open(DialogDateGroupementComponent, {
                                direction: this.appTranslateService.getDir(),
                                width: '30vw',
                                panelClass: 'custom-dialog-container',
                                data: {
                                    data: [this.detailsoffre],
                                    start: x['payload'].dtStart,
                                    end: x['payload'].dtEnd,
                                    timeaff: true,
                                    datatime: this.curentdate,
                                    timedelai: false,
                                    isnotsaved: this.isnotsaved,
                                    offretime: true,
                                },
                            });
                        } else {
                            const dialogRef = this.dialog.open(
                                DialogActeGroupementComponent,
                                {
                                    disableClose: true,
                                    direction: this.appTranslateService.getDir(),

                                    data: {
                                        bidModSeq: this.detailsoffre.bidModSeq,
                                        bidNo: this.bidNo,
                                        epbimaster: this.epBidMasterId,
                                        isgroupement: this.detailsoffre.consorYn == 'Y',
                                    },
                                    width: '50vw',
                                }
                            );
                            dialogRef.afterClosed().subscribe((result1) => {
                                if (!isEmpty(result1.data)) {
                                    this.userinfo = result1.datauser;

                                    result1.data.forEach((t) => {
                                        if (t.expandable == true && t.listLocalArticle.length > 0) {
                                            t.listLocalArticle.forEach((x) => {
                                                if ((x.affCheck = 'Y')) {
                                                    this.listbidcls.push(x);
                                                }
                                            });
                                        } else {
                                            this.listbidcls.push(t);
                                        }

                                    });
                                    this.tranferlistgroupementService.setData(this.listbidcls);
                                    console.log(
                                        'get',
                                        this.tranferlistgroupementService.getData()
                                    );
                                    let obj: LotParentArt = new LotParentArt();
                                    result1.data?.forEach((result) => {
                                        obj.bidCls = result.bidCls;
                                        obj.affectationcheck = result.affectationcheck;
                                        obj.idCls = result.idCls;
                                        obj.idParent = result.idParent;
                                        obj.epBidTypCau = result.epBidTypCau;
                                        obj.bidClsDtlDesc = result.bidClsDtlDesc;
                                        obj.guaranteeAmountCurrF = result.guaranteeAmountCurrF;
                                        obj.budgetAmtCurrF = result.budgetAmtCurrF;
                                        obj.epBidMulCls = result.epBidMulCls;
                                        obj.budgetAmt = result.budgetAmt;
                                        obj.bidClsParent = result.bidClsParent;
                                        obj.listLocalArticle = [];
                                        this.listchecked.push(obj);
                                        /*   this.listchecked.filter((a) => {
                                          a.listLocalArticle.filter((b) => {});
                                        });*/

                                    });
                                }
                            });
                        }
                    });
            } else {
                this.toast.error();
            }
        });
    }

    checkissavedoffre() {
        this.cryptoservice
            .checkSoumission(this.id, this.detailsoffre.bidModSeq)
            .subscribe((res) => {
                if (res['payload'] == 'Y') {
                    this.isnotsaved = false;
                } else if (res['payload'] == 'N') {
                    this.isnotsaved = true;
                }
            });
    }

    getdatenow() {
        this.datenow.getdatenow().subscribe((res) => (this.curentdate = res));
    }

    checkIfDossierCandidatuteBtnShown(ourCase) {

        const reqParams = {
            bidNo: this.detailsoffre.bidNo,
            bidModSeq: this.detailsoffre.bidModSeq,
        };
        this.appeloffreService
            .getResultData('check' + ourCase, null, reqParams, 'portail', 'GET')
            .subscribe({
                next: (response) => {

                    if (response['code'] == '200') {
                        this.checkFlags[ourCase] = response['payload'] === 'Y';
                    } else {
                        this.toast.error('server_error');
                    }
                },
                error: (e) => {
                    console.error(e);
                    this.toast.error('server_error');
                },
                complete: () => {
                },
            });
    }
}
